<template>
    <input type="text" v-model="displayValue"
           @blur="isInputActive = false" @focus="isInputActive = true"
           class="form-control text-right"/>
</template>
<script>
export default {
    props: {
        value: {
            default: 0
        },
        dollar: {
            default: "R$"
        }
    },
    data: function() {
        return {
            isInputActive: false
        };
    },
    computed: {
        displayValue: {
            get: function() {
                if (this.isInputActive) {
                    if (this.value) {
                        // Cursor is inside the input field. unformat display value for user
                        return this.value.toString();
                    }
                } else {
                    if (this.value) {
                        // User is not modifying now. Format display value for user interface
                        return (
                            this.dollar +
                            " " +
                            this.value
                                .toFixed(2)
                                .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                        );
                    }
                }
            },
            set: function(modifiedValue) {
                // Recalculate value after ignoring "$" and "," in user input
                let newValue = parseFloat(
                    modifiedValue.replace(/[^-?\d\.]/g, "")
                );
                // Ensure that it is not NaN
                if (isNaN(newValue)) {
                    newValue = 0;
                }
                // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
                // $emit the event so that parent component gets it
                this.$emit("input", newValue);
            }
        }
    }
};
</script>
